<script>
import CommonTableComponent from "@/components/table";
import pagination from "@/mixins/pagination";
import tableHeaders from "@/configs/tableHeaders";
import tableSearch from "@/mixins/tableSearch";
import apiEndpoints from "@/services/apiEndpoints";
import router from "@/mixins/router";
import constant from "@/configs/constant";

export default {
  components: {
    CommonTableComponent,
  },
  mixins: [pagination, tableSearch, router],
  props: ['workOrderTypeArr', 'tabIndex'],
  data() {
    return {
      headers: [
        {
          text: '依頼日',
          value: 'work_order_update_request_date',
          sortable: true,
        },
        {
          text: '作業予定日時',
          value: 'work_reservation_date',
          sortable: true,
        },
        {
          text: '作業内容',
        },
      ],
      reservations: [],
      filters: {
        zz_work_order_type_id: this.workOrderTypeArr,
        is_work_order_update_request: 1,
        column: "work_order_update_request_date",
        dir: "ASC",
      },
      busyGetData: false,
      isCollapse: false,
    }
  },
  methods: {
    async getData() {
      const url = apiEndpoints.list_reservation()
      this.busyGetData = true;
      const {status, data} = await this.$http.get(url, {...this.filters, ...this.tabIndex})
      this.busyGetData = false;
      if (status) {
        this.reservations = data.result
      }
    },
    getWorkOrderName(workReservation) {
      return workReservation?.work_order?.name;
    },
    getDischargerNameAbbreviated(workReservation) {
      return workReservation?.work_order?.case?.discharger?.name_abbreviated;
    },
    getWorkDetails(wasteOrService) {
      return wasteOrService?.waste_or_service_by_work_order?.disposal_site?.disposal_site_by_waste_category?.vendor_site_of_treatment?.name_abbreviated
    },
    updateUrlFilters () {
      this.getData()
    },
    reservationDateByFrequencyType(reservationDate) {
      if (! reservationDate.work_reservation) {
        return this.$options.filters.shortDate(reservationDate.work_reservation_date) + ' ' + reservationDate?.zz_day_of_time_zone
      }

      if (reservationDate.zz_reservation_frequency_type_id === this.$constant.zzReservationFrequencyTypeId.regularly) {
        if (! reservationDate.work_reservation.regularly_reservation_start_date) return '';

        return this.$options.filters.shortDate(reservationDate.work_reservation.regularly_reservation_start_date)
      }

      return this.$options.filters.shortDate(reservationDate.work_reservation_date) + ' ' + reservationDate?.zz_day_of_time_zone
    },
  },
  computed: {
    projectId() {
      return this.$route.params.case_id;
    },
    queryPage() {
      return this.$route.query;
    },
    urlDetail() {
      if (this.$route.name === 'schedules') {
        return 'projects.work_reservations.schedule.detail_for_sale'
      }

      return 'projects.work_reservations.schedule.detail'
    },
  },
  watch: {
    workOrderTypeArr(value) {
      this.filters.zz_work_order_type_id = value
      this.getData()
    },
    '$route' (to, from) {
      this.getData();
    }
  },
  created() {
    this.getData()
  }
}
</script>

<template>
  <div>
    <b-row class="toggle-tab cursor-pointer" v-b-toggle.collapse-1>
      <div class="mt-2 mb-2 col font-size-16 fw-bold">■ 変更依頼</div>
      <div class="col">
        <div class="mt-2 mb-2 font-size-16 fw-bold d-flex justify-content-end align-items-center">{{ reservations.length }}件
          <span v-if="isCollapse" class="ml-1 fa fa-chevron-up fa-lg"></span>
          <span v-if="! isCollapse" class="ml-1 fa fa-chevron-down fa-lg"></span>
        </div>
      </div>
    </b-row>
    <b-collapse id="collapse-1" class="mt-2" v-model="isCollapse">
      <b-overlay
        :show="busyGetData"
        rounded
        opacity="0.6"
        spinner-small
        spinner-variant="primary"
      >
        <CommonTableComponent :height-class="`table-wrapper-600`">
        <thead class="table-light">
        <tr>
          <th class="text-center"
            v-for="(item, index) in headers"
            :key="index"
            :class="getHeaderClass(item)"
          >
                  <span v-if="item.sortable" @click="clickSort(item.value)">
                    {{ item.text }}
                    <i :class="getSortClass(item.value)"></i>
                  </span>
            <span v-else>
                    {{ item.text }}
                  </span>
          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="item in reservations"
            @click.exact="
                  redirectRoute(
                    urlDetail,
                    {
                      work_reservation_id: item.work_reservation_id,
                    },
                    {update_request:1},
                    queryPage,
                    'projects/work-reservations/schedules'
                  )
                "
            @click.ctrl="
                  redirectRouteTargetBlank(
                    urlDetail,
                    {
                      work_reservation_id: item.work_reservation_id,
                    },
                    {update_request:1},
                    queryPage,
                    'projects/work-reservations/schedules'
                  )
                "
            class="cursor-pointer"
        >
          <td>{{ item.work_reservation.work_order_update_request_date | shortDate }}</td>
          <td>{{reservationDateByFrequencyType(item)}}</td>
          <td>
            {{ getWorkOrderName(item.work_reservation) && getWorkOrderName(item.work_reservation) + ', ' }}
            {{ getDischargerNameAbbreviated(item.work_reservation) && getDischargerNameAbbreviated(item.work_reservation) + ', ' }}
            <div>
              <span v-for="(wasteOrService, index) in item.work_reservation.wastes_or_services_by_work_reservation">
                {{ getWorkDetails(wasteOrService) && getWorkDetails(wasteOrService) + ', ' }}
              </span>
            </div>
            {{ item.work_reservation.work_order_update_requests }}
          </td>
        </tr>
        <tr v-if="!reservations.length">
          <td colspan="6" class="text-center">
            データなし。
          </td>
        </tr>
        </tbody>
      </CommonTableComponent>
      </b-overlay>
    </b-collapse>
  </div>
</template>

<style lang="scss" scoped>
.toggle-tab {
  border: 1px solid #ced4da;
  border-radius: 10px;
  margin: 10px 0px;
}
</style>

